export default `
  fragment VehiclePreview on VehiclesVehicles {
    id
    slug
    name
    lowestPrice
    buildyear
    isSold
    odometer
    transmission
    power_hp
    fuel
    cylindersCapacity: cylinders_capacity,

    dealer {
      title
      city
      tel
      logo {
        id
        url
        alternativeText
        name
      }
    }

    image {
      id
      url
    }

    images(sort: "index:asc") {
      id
      url
    }

    videos
  }
`;
